import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Link as MuiLink,
  TextField,
  Typography
} from '@mui/material'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router'
import { useAuthStore } from '../../hooks/useAuthStore'
import { useDeleteUserMutation } from '../../hooks/useMutations/useUsersMutations'
import { AssignAdminModal } from './AssingAdminAccount'

export const DeleteAccountModal = NiceModal.create(() => {
  const { accessToken, userId } = useAuthStore()
  const modal = useModal()
  const { t } = useTranslation()
  const [text, setText] = useState('')
  const navigate = useNavigate()

  const mutation = useDeleteUserMutation()

  const handleSave = () => {
    mutation.mutate(
      { accessToken: accessToken!, userId: userId! },
      {
        onSuccess: () => {
          navigate('/sign-in')
        },
        onError: (error: any) => {
          const companiesWithFullAccess =
            error?.response?.data?.data?.details?.companies
          NiceModal.show(AssignAdminModal, {
            companies: companiesWithFullAccess
          })
        },
        onSettled: () => {
          modal.remove()
        }
      }
    )
  }

  return (
    <Dialog
      open={modal.visible}
      onClose={() => modal.remove()}
      sx={{
        '& .MuiDialog-paper': {
          width: '37.5rem',
          padding: '1.5rem'
        }
      }}
    >
      <DialogTitle sx={{ padding: '1.5rem' }}>
        <Typography fontWeight='bold' variant='h6' component='span'>
          {t('delete_account_modal.title')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: '1.5rem' }}>
        <Typography variant='body1' marginBottom={'2rem'}>
          <Trans
            i18nKey='delete_account_modal.explanation'
            components={[
              <Typography
                component='span'
                fontWeight='bold'
                display='inline'
              />,
              <MuiLink
                component={Link}
                to='/terms'
                target='_blank'
                rel='noopener noreferrer'
                underline='hover'
                display='inline'
                color='info.main'
              />
            ]}
          />
        </Typography>
        <Typography variant='body1'>
          {t('delete_account_modal.confirmation_explanation')}
        </Typography>
        <FormControl fullWidth sx={{ py: '1.5rem' }}>
          <TextField
            value={text}
            onChange={e => setText(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'text.secondary'
                },
                '&:hover fieldset': {
                  borderColor: 'text.secondary'
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'text.secondary'
                }
              }
            }}
          ></TextField>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => modal.remove()}
          sx={{
            textTransform: 'capitalize',
            color: 'text.secondary',
            borderColor: 'text.secondary',
            '&:hover': {
              borderColor: 'text.secondary',
              backgroundColor: 'rgba(255, 255, 255, 0.1)'
            }
          }}
        >
          {t('common.cancel')}
        </Button>
        <Button
          variant='contained'
          onClick={handleSave}
          disabled={
            !text || text !== t('delete_account_modal.confirmation_text')
          }
          color='error'
          sx={{ textTransform: 'capitalize' }}
        >
          {mutation.isPending
            ? t('delete_account_modal.deleting')
            : t('delete_account_modal.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
})
